export default __webpack_public_path__ + "static/media/airport.07837845.png";